import {ModifierFragment} from '../../../gql/graphql';
import {trimToMaxLength} from '../../utils/trimToMaxLength';

export class ModifierModel {
  public id: string;
  public quantity: number;
  public label: string;
  public details?: string;

  constructor(modifier: ModifierFragment) {
    this.id = modifier.id!;
    this.quantity = modifier.quantity!;
    this.label = modifier.label?.translated ?? modifier.label?.original ?? /* istanbul ignore next */ '';
    this.details = modifier.details?.translated ?? modifier.details?.original ?? /* istanbul ignore next */ '';
  }

  public toString(maxLength?: number): string {
    if (!this.details) {
      return trimToMaxLength(this.label, maxLength);
    }

    return `${this.label}: ${trimToMaxLength(this.details, maxLength)}`;
  }

  public static convertToStringArray(modifiers: (ModifierFragment | null)[], maxLength?: number): string[] {
    return modifiers
      .filter((modifier) => !!modifier)
      .map((modifier) => new ModifierModel(modifier).toString(maxLength));
  }
}
